import * as React from "react"
import {InfoModal, InfoModalButton} from "./InfoModal"
import {WithModalStore} from "../App"

interface Props extends WithModalStore {
  heading: string
  message: string
  button: InfoModalButton | null
}

export function MessageModal({heading, message, button, modalStore}: Props) {
  return <InfoModal heading={heading} message={message} onDismiss={onDismiss} button={button} />

  function onDismiss() {
    modalStore.hideModal()
  }
}



// WEBPACK FOOTER //
// ./src/components/MessageModal.tsx